// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.holder {
  max-width: 100%;
}
form {
  background-color: #efeff7 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/packages-module/package-edit/package-edit.component.less"],"names":[],"mappings":"AAEA;EACI,eAAA;AADJ;AAIA;EACI,oCAAA;AAFJ","sourcesContent":["@import (reference) url('../../../styles.less');\n\n.holder {\n    max-width: 100%;\n}\n\nform {\n    background-color: @ltpurple !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
